import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\UpdateScreenController::__invoke
* @see app/Http/Controllers/Screen/UpdateScreenController.php
* @route '/api/screen-settings/{screen}'
*/
const UpdateScreenController = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateScreenController.url(args, options),
    method: 'put',
})

UpdateScreenController.definition = {
    methods: ["put"],
    url: '/api/screen-settings/{screen}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Screen\UpdateScreenController::__invoke
* @see app/Http/Controllers/Screen/UpdateScreenController.php
* @route '/api/screen-settings/{screen}'
*/
UpdateScreenController.url = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { screen: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { screen: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            screen: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        screen: typeof args.screen === 'object'
        ? args.screen.id
        : args.screen,
    }

    return UpdateScreenController.definition.url
            .replace('{screen}', parsedArgs.screen.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\UpdateScreenController::__invoke
* @see app/Http/Controllers/Screen/UpdateScreenController.php
* @route '/api/screen-settings/{screen}'
*/
UpdateScreenController.put = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateScreenController.url(args, options),
    method: 'put',
})

export default UpdateScreenController